exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.panel-body--map[data-v-5b74e8bd] {\n    padding: 0;\n}\n.panel-body--map div[data-v-5b74e8bd] {\n    border-radius: inherit;\n}\n#map[data-v-5b74e8bd] {\n    height: 500px;\n}\n.content-left[data-v-5b74e8bd] {\n    transition: all 0.5s ease;\n}\n.w-100[data-v-5b74e8bd] {\n    width: 100%;\n}\n.border[data-v-5b74e8bd] {\n    border: solid 2px #b71818;\n    margin: -1px;\n}\n.text-danger[data-v-5b74e8bd] {\n    color: #cf1313;\n}\n", ""]);

// exports
